<template>
  <el-table-wrapper :class="tableClass" v-loading="loading" :data="data" :columns="columns" :show-custom-header="showCustomSearchHeader" :show-search-tool="showSearchTool" :show-overflow-tooltip="true" :pagination="pagination" :column-default="columnDefault">
    <template slot-scope="scope" slot="rssi-slot">
      <i :class="getSignalStrengthIconClass(scope.row.rssi)" />
    </template>
  </el-table-wrapper>
</template>

<script>
import { clone, remove } from 'lodash';
import { convertValuByUnit } from '@/utils/number';
import { getValueAfterCheckEmpty } from '@/utils/string';
import { columnDefault } from '@/constants/table';
import { getSignalStrengthIconClass, getClientName, getClientConnectDurationString, showClientRssi, showClientSnr, showClientConnectDuration } from '@/utils/wireless-device';

/**
 * 무선 AP 접속자 정보 테이블 컴포넌트
 */
export default {
  name: 'WApClientTable',
  props: {
    /**
     * 테이블 데이터
     */
    data: {
      type: Array,
    },
    /**
     * 테이블 데이터 로딩 상태
     */
    loading: {
      type: Boolean,
      default: false,
    },
    /**
     * 커스텀 검색 헤더 사용 여부
     */
    showCustomSearchHeader: {
      type: Boolean,
      default: true,
    },
    /**
     * 커스텀 검색 헤더 제공 여부
     */
    showSearchTool: {
      type: Boolean,
      default: false,
    },
    /**
     * 페이징 처리 여부
     */
    pagination: {
      type: Boolean,
      default: true,
    },
    /**
     * 장비 벤더 아이디
     */
    objCompanyId: {
      type: Number,
    },
    tableClass: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      columnDefault,
      columns: [],
      /**
       * 컬럼
       * @type {Array}
       */
      basicColumns: [
        {
          prop: 'clientName',
          label: '접속자명',
          sortable: true,
          searchable: true,
          formatter: (row) => getClientName(row.clientName, row.ipAddress),
          orderbyIndex: 1,
        },
        {
          prop: 'ipAddress',
          label: 'IP',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
          orderbyIndex: 2,
        },
        {
          prop: 'macAddress',
          label: 'MAC',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
          orderbyIndex: 3,
        },
        {
          prop: 'companyName',
          label: '제조사',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
          orderbyIndex: 4,
        },
        {
          prop: 'os',
          label: 'OS',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
          orderbyIndex: 5,
        },
        {
          prop: 'ssid',
          label: 'WLAN',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
          orderbyIndex: 6,
        },
        {
          prop: 'radioBand',
          label: '주파수 대역',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
          orderbyIndex: 7,
        },
        {
          prop: 'rssi',
          label: '신호세기',
          width: 74,
          sortable: true,
          align: 'center',
          scopedSlot: 'rssi-slot',
          orderbyIndex: 8,
        },
        {
          prop: 'connectDuration',
          label: '접속 유지 시간',
          sortable: true,
          searchable: false,
          formatter: (row, column, value) => getClientConnectDurationString(value),
          orderbyIndex: 9,
        },
        {
          label: '트래픽',
          headerAlign: 'center',
          orderbyIndex: 10,
          childColumns: [
            {
              prop: 'trafficBpsIn',
              label: 'IN',
              sortable: true,
              headerAlign: 'center',
              formatter: (row, column, value) => convertValuByUnit(value, 'bps', true, true, true),
              width: 80,
            },
            {
              prop: 'trafficBpsOut',
              label: 'OUT',
              sortable: true,
              headerAlign: 'center',
              formatter: (row, column, value) => convertValuByUnit(value, 'bps', true, true, true),
              width: 80,
            },
          ],
        },
        {
          prop: 'snr',
          label: 'SNR',
          sortable: true,
          searchable: false,
          formatter: (row, column, value) => convertValuByUnit(value, 'dB', true, true, true),
          orderbyIndex: 11,
        },
      ],
    };
  },
  watch: {
    objCompanyId: {
      immediate: true,
      handler() {
        this.columns = [];
        this.$nextTick(() => {
          const columns = clone(this.basicColumns);
          remove(columns, (data) => (data.prop === 'rssi' && !showClientRssi(this.objCompanyId)) || (data.prop === 'snr' && !showClientSnr(this.objCompanyId)) || (data.prop === 'connectDuration' && !showClientConnectDuration(this.objCompanyId)));
          this.columns = columns;
        });
      },
    },
  },
  methods: {
    getSignalStrengthIconClass,
    /**
     * 공백 데이터 처리 formatter
     * @author Ju
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/performance/components/wireless/ApClientTable.vue